const apiMapUrl = [
  {
    url: '/api/category/v2/',
    previewUrl: '/api/preview/category/v2/',
  },
  {
    url: '/api/search/sitesearch/v2',
    previewUrl: '/api/preview/search/sitesearch/v2',
  },
  {
    url: '/api/search/v2/productSuggestions',
    previewUrl: '/api/preview/search/v2/productSuggestions',
  },
  {
    url: '/api/product/v2/',
    previewUrl: '/api/preview/product/v2/',
  },
  {
    url: '/api/search/v2/productRecommendation',
    previewUrl: '/api/preview/search/v2/productRecommendation',
  },
];

/**
 * Reads the api and pricePreview and returns new preview experience api
 * @param api
 * @param pricePreview
 * @returns {string}
 */
const redirectToPreviewAPI = (api, pricePreview) => {
  const apiIndex = apiMapUrl.findIndex(apiMap => Array.isArray(api.match(apiMap.url)));
  if (apiIndex !== -1) {
    return api.indexOf('?') !== -1
      ? `${api.replace(`${apiMapUrl[apiIndex].url}`, `${apiMapUrl[apiIndex].previewUrl}`)}&pricePreview=${pricePreview}`
      : `${api.replace(`${apiMapUrl[apiIndex].url}`, `${apiMapUrl[apiIndex].previewUrl}`)}?pricePreview=${pricePreview}`;
  }
  return api;
};
export default redirectToPreviewAPI;
